<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <!-- <ul class="sidebar-menu">
        <li v-for="menu in $config.MODULES"
          v-bind:key="menu.id"
          :class="{ disabled: menu.disabled}">
          <router-link class="menu-item"
            v-if="!menu.disabled"
            :to="'/' + menu.id">
            <i :class="menu.icon"
              v-if="menu.icon"></i>
            <span>{{ menu.title }}</span>
          </router-link>
          <a class="menu-item"
            v-if="menu.disabled">
            <i :class="menu.icon"
              v-if="menu.icon"></i>{{ menu.title }}
          </a>
        </li>
      </ul> -->
      <el-menu
        default-active="2"
        class="sidebar-menu"
      >
        <el-menu-item
          v-for="(menu, index) in $config.MODULES"
          :key="menu.id"
          :index="index"
        >
          <!-- <i :class="menu.icon"
              v-if="menu.icon"></i> -->
          <router-link
            class="menu-item"
            v-if="!menu.disabled"
            :to="'/' + menu.id"
          >
            <i
              :class="menu.icon"
              v-if="menu.icon"
            ></i>
            <span>{{ menu.title }}</span>
          </router-link>
          <!-- <a class="menu-item"
            v-if="menu.disabled">
            <i :class="menu.icon"
              v-if="menu.icon"></i>{{ menu.title }}
          </a> -->
        </el-menu-item>

        <!-- 点评管理 -->
        <el-submenu index="7">
          <template slot="title">
            <i class="fa fa-comment"></i>
            <span class="submenu_title">点评管理</span>
          </template>
          <el-menu-item-group class="menu_group">
            <!-- <template slot="title"></template> -->
            <el-menu-item index="7-1">
              <router-link
                class="menu-item"
                to="/reviews"
              >
                <span>点评中包含的基本信息入库</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="7-2">
              <router-link
                class="menu-item"
                to="/reviews/manage"
              >
                <span>点评审核</span>
              </router-link>
            </el-menu-item>
             <el-menu-item index="7-3">
              <router-link
                class="menu-item"
                to="/reviews/analysis"
              >
                <span>点评智能分析处理</span>
              </router-link>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!-- 企业账号管理 -->
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/enterprise"
          >
            <i class="fa fa-user"></i>
            <span>企业账号管理</span>
          </router-link>
        </el-menu-item>

        <!-- 收款管理 -->
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/proceeds"
          >
            <i class="fa fa-envelope"></i>
            <span>收款管理</span>
          </router-link>
        </el-menu-item>

        <!-- 会议频道管理 -->
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/meeting"
          >
            <i class="fa fa-commenting"></i>
            <span>会议频道管理</span>
          </router-link>
        </el-menu-item>
        <!-- 销售线索管理 -->
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/sales"
          >
            <i class="fa fa-info-circle"></i>
            <span>销售线索管理</span>
          </router-link>
        </el-menu-item>
        <!-- 厂商管理 -->
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/company"
          >
            <i class="fa fa-database"></i>
            <span>厂商管理</span>
          </router-link>
        </el-menu-item>
        <el-submenu index="10">
          <template slot="title">
            <i class="fa fa-th-large"></i>
            <span class="submenu_title"> 类别管理</span>
          </template>
          <el-menu-item-group class="menu_group">
            <!-- <template slot="title"></template> -->
            <el-menu-item index="10-1">
              <router-link
                class="menu-item"
                to="/category"
              >
                <span>类别列表</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="10-2">
              <router-link
                class="menu-item"
                to="/funcList/new/:id"
              >
                <span>功能清单</span>
              </router-link>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/product"
          >
            <i class="fa fa-inbox"></i>
            <span>产品管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/analysis"
          >
            <i class="fa fa-line-chart"></i>
            <span>智能分析管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/news"
          >
            <i class="fa fa-newspaper-o"></i>
            <span>新闻管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/document"
          >
            <i class="fa fa-file-text-o"></i>
            <span>文档管理</span>
          </router-link>
        </el-menu-item>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/person"
          >
            <i class="fa fa-users"></i>
            <span>转型100人</span>
          </router-link>
        </el-menu-item>
        <el-menu-item>
          <router-link
            class="menu-item"
            to="/industry"
          >
            <i class="fa fa-tags"></i>
            <span>行业及标签配置</span>
          </router-link>
        </el-menu-item>

      </el-menu>
      <!-- /.sidebar menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import Avatar from 'vue-avatar'
export default {
  name: 'DashboardSidebar',
  mounted: function () {
    $(document).ready(function ($) {
      $('.main-sidebar > div').slimScroll({
        width: '230px',
        position: 'left',
        size: '3px',
        height: '95vh'
      })
    })
  },
  components: {
    Avatar
  }
}
</script>

<style lang="sass" scoped>
.sidebar-menu
  margin-top: 15px
  background-color: transparent
  .menu-item.active
    color: #fff
    background: rgba(0, 0, 0, 0.5)
    border-left-color: #fff
  .el-menu-item:hover
    background-color: rgba(0, 0, 0, 0.5)
  .el-menu-item
    height: auto
    line-height: normal
    padding-left: 0!important
  .submenu_title
    color: #fff
  .sidebar-menu
    .fa
      display: inline-block
      width: 30px
  .menu_group
    background-color: transparent
</style>
<style lang="sass">
.el-submenu__title:hover
  background-color: rgba(0, 0, 0, 0.5)!important
.sidebar-menu
  .el-menu
    background-color: transparent
    .el-submenu__title
      &:hover
        background-color: rgba(0, 0, 0, 0.5)
    .menu_group
      .el-menu-item
        padding: 0
        a
          padding: 0 0 0 20px
          display: block
        &.is-active
          background-color: rgba(0, 0, 0, 0.5)
</style>



// WEBPACK FOOTER //
// Sidebar.vue?68a22f20